/*
 * SMParts — die Zahlen zaehlen hoch, sobald sie ins Bild kommen.
 *
 * Zwei Entscheidungen, die das Ruckeln verhindern:
 *
 * 1. Gezaehlt wird mit requestAnimationFrame, nicht mit setInterval.
 *    setInterval feuert nach Uhrzeit und trifft den Bildaufbau nicht;
 *    beim Scrollen sieht das aus, als haenge die Zahl. rAF laeuft im
 *    Takt des Bildschirms.
 *
 * 2. Beschrieben wird nur textContent einer <span> mit fester
 *    Ziffernbreite. Kein Layout aussen herum aendert sich, der
 *    Browser muss also nicht die ganze Seite neu rechnen.
 *
 * Wer im Betriebssystem Bewegung abgestellt hat, sieht sofort den
 * Endwert — ohne Skriptlauf.
 */
(function () {
  'use strict';

  var RUHE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DAUER = 1100;

  /* Schnell anlaufen, weich auslaufen. */
  function weich(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function zaehle(el) {
    var ziel = parseFloat((el.getAttribute('data-smp-zahl') || '').replace(',', '.'));
    if (isNaN(ziel)) return;

    /* Nachkommastellen des Zielwerts uebernehmen, damit aus 4,8 nicht 5 wird. */
    var roh = (el.getAttribute('data-smp-zahl') || '').replace(',', '.');
    var punkt = roh.indexOf('.');
    var stellen = punkt === -1 ? 0 : roh.length - punkt - 1;
    var start = performance.now();

    function schritt(jetzt) {
      var t = Math.min(1, (jetzt - start) / DAUER);
      var wert = ziel * weich(t);
      el.textContent = wert.toFixed(stellen).replace('.', ',');
      if (t < 1) requestAnimationFrame(schritt);
      else el.textContent = roh.replace('.', ',');
    }

    el.textContent = (0).toFixed(stellen).replace('.', ',');
    requestAnimationFrame(schritt);
  }

  function einrichten() {
    var zahlen = document.querySelectorAll('[data-smp-zaehlen]:not([data-smp-fertig])');
    if (!zahlen.length) return;

    if (RUHE || !('IntersectionObserver' in window)) {
      zahlen.forEach(function (el) { el.setAttribute('data-smp-fertig', '1'); });
      return;
    }

    var beobachter = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        beobachter.unobserve(e.target);
        e.target.setAttribute('data-smp-fertig', '1');
        zaehle(e.target);
      });
    }, { threshold: 0.4 });

    zahlen.forEach(function (el) { beobachter.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', einrichten);
  } else {
    einrichten();
  }

  document.addEventListener('shopify:section:load', einrichten);
})();
